/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { MONTH_MAPPER } from '../transformers/contactInfo.transform';
import {
  addOrUpdateCrRegisterUser,
  fetchProfileDetailsForCR,
  post as cdpPost,
} from '../lib/utils/axiosCDPFetcher';
import { post, removeFromBlockList } from '../lib/utils/axiosFetcher';
import { store } from '../store/store';
import axios from 'axios';
import { ICOIAndICommunities } from '../types/registerUserTypes';
import { getCookie } from 'cookies-next';
import omit from 'lodash/omit';
import * as cdpService from '../services/CdpService';
import { CDP_EVENTS } from '../../src/constants';
import { getValidateCrEmailIdURL } from '../lib/utils/common';
import { logger } from 'src/logger';
import {
  buildPreferredSitesForCdp,
  buildPreferredSitesForDap,
  getPreferredSiteIdForRegistration,
  getPreferredSiteNameForRegistration,
} from '../lib/utils/saveSite';

const PROFILE_VERIFY_TOKEN_KEY = 'myProfileVerificationToken';
// import * as cdpService from '../services/CdpService';
// import { CDP_EVENTS } from '../constants';

export const getStringValFromArray = (
  dataList: any,
  keyName: string,
  subKey: string,
  isIndex?: boolean
) => {
  const arr =
    dataList?.map((data: any) => ({
      sitecoreId: data?.sitecoreId || '',
      id: isIndex ? (data?.[keyName] + 1).toString() : data?.[keyName],
      text: data?.[subKey],
    })) || [];
  return { items: [...arr], lastUpdated: new Date() };
};

export const getStringValFromArrayForCDP = (
  dataList: any,
  keyName: string,
  subKey: string,
  isIndex?: boolean
) => {
  const arr =
    dataList?.map((data: any) => ({
      sitecoreId: data?.sitecoreId || '',
      id: isIndex ? (data?.[keyName] + 1).toString() : data?.[keyName],
      text: data?.[subKey],
    })) || [];
  return arr;
};

export const getCommunities = (dataList: any) => {
  const communityList: any = [];
  dataList &&
    dataList?.map((data: any) => {
      if (data?.communities && data?.communities.length > 0) {
        communityList.push(...data?.communities);
      }
    });
  const uniqueCommunityList = communityList?.reduce((list: any, currentItem: any) => {
    if (!list.find((item: any) => item.value === currentItem.value)) {
      list.push(currentItem);
    }
    return list;
  }, []);
  return uniqueCommunityList;
};

export const addOrUpdateCrRegistrationDetails = async (
  source: string,
  guestRef?: string,
  sitesettingsFromNumber?: string,
  isSendSmsEnabled?: boolean
) => {
  const state = store.getState();
  const cookieName = 'bid_' + process.env.NEXT_PUBLIC_CDP_CLIENT_KEY;
  const conditionOfInterest = getStringValFromArray(
    state?.registrationDetails?.selectedCOIList,
    'value',
    'key'
  );

  const communityList = getCommunities(state?.registrationDetails?.selectedCOIList);
  const communities = getStringValFromArray(communityList, 'value', 'key');
  const crQueryParams = state?.crQueryParam?.queryParamList || {};
  const crQueryParamWithoutGclId = omit(crQueryParams, ['gclid', 'fbclid', 'atid']);
  const secondaryConsent = {
    isSecondaryConsentAccepted:
      (state?.registrationDetails?.registration?.agree && 'True') || 'False',
    secondaryConsentAcceptedDateTime: new Date(),
    isSecondaryContactMediumPhone: state?.registrationDetails?.contactPreference?.Phone
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumEmail: state?.registrationDetails?.contactPreference?.Email
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumSMS:
      (state?.registrationDetails?.contactPreference?.textMessaging ||
        state?.registrationDetails?.contactPreference?.SMS) &&
      state?.registrationDetails?.contactPreference.isMobile
        ? 'Yes'
        : 'No',
    isSecondaryContactMediumAutomatedDialer: state?.registrationDetails?.contactPreference
      ?.Automateddialer
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumArtificialVoice: state?.registrationDetails?.contactPreference
      ?.Artificialvoice
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumPreRecordedVoice: state?.registrationDetails?.contactPreference[
      'Pre-recordedvoice'
    ]
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumDirectMail: state?.registrationDetails?.contactPreference?.DirectEmail
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumInsightSurveys: state?.registrationDetails?.contactPreference
      ?.InsightSurveys
      ? 'Yes'
      : 'No',
    combinedConsentAccepted: null,
    combinedConsentAcceptedDateTime: null,
  };

  const travelDistance = state?.registrationDetails?.locationDetails?.travelDistance || '';
  const interestedInAtHomeTrials = state?.registrationDetails?.locationDetails?.homeTrial || '';
  const selectedRelevantItems = getStringValFromArray(
    state?.registrationDetails?.patientDetails,
    'keyIndex',
    'name',
    false
  );
  const zipCode = state?.registrationDetails?.locationDetails?.zipcode || '';
  const preferredSiteId = getPreferredSiteIdForRegistration();
  const payload = {
    ref: guestRef,
    email: state?.registrationDetails?.registration?.email || '',
    firstName: state?.registrationDetails?.aboutYourSelf?.firstName || '',
    lastName: state?.registrationDetails?.aboutYourSelf?.lastName || '',
    postCode: state?.registrationDetails?.locationDetails?.zipcode || '',
    phoneNumbers: state?.registrationDetails?.contactPreference?.contactNumber?.split() || [],
    zipCode,
    dateOfBirth: state?.registrationDetails?.dob?.dob,
    gender: state?.registrationDetails?.dob?.gender,
    isMobile: state?.registrationDetails?.contactPreference.isMobile,
    dataExtension: {
      UtmParameter: crQueryParamWithoutGclId,
      gclId: crQueryParams?.gclid || '',
      atId: crQueryParams?.atid || '',
      fbclId: crQueryParams?.fbclid || '',
      conditionOfInterest: conditionOfInterest,
      communities: communities,
      travelDistance,
      source,
      secondaryConsent,
      selectedRelevantItems,
      interestedInAtHomeTrials: interestedInAtHomeTrials,
      latitude: state?.registrationDetails?.locationDetails?.latitude || 0,
      longitude: state?.registrationDetails?.locationDetails?.longitude || 0,
      ...(preferredSiteId ? { preferredSites: buildPreferredSitesForCdp(preferredSiteId) } : {}),
    },
    browserId: getCookie(cookieName),
  };
  try {
    // Make the API call to fetch CDP Data
    const response = await addOrUpdateCrRegisterUser(
      `/api/contacts/AddOrUpdateCrRegistrationDetails/${guestRef}?guestType=customer`,
      payload
    );
    if (
      response?.data != null &&
      secondaryConsent.isSecondaryConsentAccepted === 'True' &&
      secondaryConsent.isSecondaryContactMediumSMS === 'Yes' &&
      isSendSmsEnabled
    ) {
      const unblockSMSPayload = {
        FromNumber:
          (sitesettingsFromNumber != null && sitesettingsFromNumber?.indexOf('+') > -1
            ? sitesettingsFromNumber
            : `+1${sitesettingsFromNumber}`) || '',
        ToNumber:
          (payload.phoneNumbers[0]?.indexOf('+') > -1
            ? payload.phoneNumbers[0]
            : `+1${payload.phoneNumbers[0]}`) || '',
      };
      removeFromBlockList(unblockSMSPayload);
    }
    if (communities && Array.isArray(communities.items) && communities.items.length > 0) {
      setTimeout(() => {
        cdpService.event(CDP_EVENTS.ADD_COMMUNITY_CR, {
          communityName: Array.isArray(communities.items)
            ? communities.items.map((item: any) => item.text).join(', ')
            : '',
        });
      }, 5000);
    }

    return response;
  } catch (_error) {}
};

export const pad = (n: any) => {
  if (n < 10) return '0' + n;
  return n;
};

export const AddOrUpdateCRRegDetails = async (source: string, guestRef?: string) => {
  const state = store.getState();
  const cookieName = 'bid_' + process.env.NEXT_PUBLIC_CDP_CLIENT_KEY;
  const conditionOfInterest = getStringValFromArray(
    state?.registrationDetails?.selectedCOIList,
    'value',
    'key'
  );

  const communityList = getCommunities(state?.registrationDetails?.selectedCOIList);
  const communities = getStringValFromArray(communityList, 'value', 'key');
  const crQueryParams = state?.crQueryParam?.queryParamList || {};
  const crQueryParamWithoutGclId = omit(crQueryParams, ['gclid', 'fbclid', 'atid']);
  const secondaryConsent = {
    isSecondaryConsentAccepted:
      (state?.registrationDetails?.registration?.agree && 'True') || 'False',
    secondaryConsentAcceptedDateTime: new Date(),
    isSecondaryContactMediumPhone: state?.registrationDetails?.contactPreference?.Phone
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumEmail: state?.registrationDetails?.contactPreference?.Email
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumSMS:
      (state?.registrationDetails?.contactPreference?.textMessaging ||
        state?.registrationDetails?.contactPreference?.SMS) &&
      state?.registrationDetails?.contactPreference.isMobile
        ? 'Yes'
        : 'No',
    isSecondaryContactMediumAutomatedDialer: state?.registrationDetails?.contactPreference
      ?.Automateddialer
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumArtificialVoice: state?.registrationDetails?.contactPreference
      ?.Artificialvoice
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumPreRecordedVoice: state?.registrationDetails?.contactPreference[
      'Pre-recordedvoice'
    ]
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumDirectMail: state?.registrationDetails?.contactPreference?.DirectEmail
      ? 'Yes'
      : 'No',
    isSecondaryContactMediumInsightSurveys: state?.registrationDetails?.contactPreference
      ?.InsightSurveys
      ? 'Yes'
      : 'No',
    combinedConsentAccepted: null,
    combinedConsentAcceptedDateTime: null,
  };

  const travelDistance = state?.registrationDetails?.locationDetails?.travelDistance || '';
  const interestedInAtHomeTrials = state?.registrationDetails?.locationDetails?.homeTrial || '';
  const selectedRelevantItems = getStringValFromArray(
    state?.registrationDetails?.patientDetails,
    'keyIndex',
    'name',
    false
  );
  const zipCode = state?.registrationDetails?.locationDetails?.zipcode || '';
  const preferredSiteId = getPreferredSiteIdForRegistration();
  const preferredSiteName = getPreferredSiteNameForRegistration();
  const payload = {
    ref: guestRef,
    email: state?.registrationDetails?.registration?.email || '',
    firstName: state?.registrationDetails?.aboutYourSelf?.firstName || '',
    lastName: state?.registrationDetails?.aboutYourSelf?.lastName || '',
    postCode: state?.registrationDetails?.locationDetails?.zipcode || '',
    phoneNumbers: state?.registrationDetails?.contactPreference?.contactNumber?.split() || [],
    zipCode,
    dateOfBirth: state?.registrationDetails?.dob?.dob,
    gender: state?.registrationDetails?.dob?.gender,
    isMobile: state?.registrationDetails?.contactPreference.isMobile,
    dataExtension: {
      UtmParameter: crQueryParamWithoutGclId,
      gclId: crQueryParams?.gclid || '',
      atId: crQueryParams?.atid || '',
      fbclId: crQueryParams?.fbclid || '',
      conditionOfInterest: conditionOfInterest,
      communities: communities,
      travelDistance,
      source,
      secondaryConsent,
      selectedRelevantItems,
      interestedInAtHomeTrials: interestedInAtHomeTrials,
      latitude: state?.registrationDetails?.locationDetails?.latitude || 0,
      longitude: state?.registrationDetails?.locationDetails?.longitude || 0,
      ...(preferredSiteId
        ? { preferredSites: buildPreferredSitesForDap(preferredSiteId, preferredSiteName) }
        : {}),
    },
    browserId: getCookie(cookieName),
  };
  try {
    // Make the API call to fetch CDP Data
    const response = await post(`/Patient/AddOrUpdateCRRegDetails`, payload);
    return response;
  } catch (error: any) {
    logger.error(`${process.env.NEXT_PUBLIC_BASE_URL}${'/Patient/AddOrUpdateCRRegDetails'}`, {
      error: error?.message,
      payload: payload,
    });
    throw error;
  }
};

export const addOrUpdateCrMyProfile = async (
  source: string,
  formData: any,
  isVerifiedEmail: boolean,
  guestRef?: string,
  language?: string,
  sendMailingListId?: any,
  siteSettingsId?: any,
  sitesettingsFromNumber?: string,
  isSendSmsEnabled?: boolean
) => {
  const secondaryConsent = formData?.SecondaryConsentMedium
    ? {
        isSecondaryConsentAccepted: formData?.SecondaryConsentMedium ? 'True' : 'False',
        secondaryConsentAcceptedDateTime: new Date(),
        isSecondaryContactMediumPhone: formData?.SecondaryConsentMediumPhone ? 'Yes' : 'No',
        isSecondaryContactMediumEmail: formData?.SecondaryConsentMediumEmail ? 'Yes' : 'No',
        isSecondaryContactMediumSMS: Boolean(formData?.isMobile)
          ? formData?.SecondaryConsentMediumSMS
            ? 'Yes'
            : 'No'
          : 'No',
        isSecondaryContactMediumAutomatedDialer: formData?.SecondaryConsentMediumAutomatedDialer
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumArtificialVoice: formData?.SecondaryConsentMediumArtificialVoice
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumPreRecordedVoice: formData?.SecondaryConsentMediumPrerecordedVoice
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumDirectMail: formData?.SecondaryConsentMediumDirectEmail
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumInsightSurveys: formData?.SecondaryConsentMediumInsightSurveys
          ? 'Yes'
          : 'No',
      }
    : null;

  const getDOB = (formData: any) => {
    if (formData?.Day && formData?.Month && formData?.Year) {
      return `${formData.Year}-${pad(
        MONTH_MAPPER[formData.Month as keyof typeof MONTH_MAPPER]
      )}-${formData.Day.toString().padStart(2, '0')}`;
    } else {
      return '';
    }
  };

  const dob = getDOB(formData);

  const selectedRelevantItems = {
    items:
      formData?.patientEnquiries?.items?.map((enquiry: any) => ({
        sitecoreId: enquiry?.sitecoreId || '',
        id: enquiry?.id || '',
        text: enquiry?.text || '',
      })) || [],
  };
  const payload = {
    ref: guestRef,
    email: formData?.Email || '',
    firstName: formData?.FirstName || '',
    lastName: formData?.LastName || '',
    postCode: formData?.Zipcode || '',
    address: formData?.CrAddress || '',
    state: formData?.State || '',
    city: formData?.City || '',
    isMobile: formData?.isMobile ? formData?.isMobile : false,
    phoneNumbers: formData.ContactNumber?.split() || [],
    zipCode: formData?.Zipcode,
    dateOfBirth: dob,
    gender: formData?.Gender,
    dataExtension: {
      source,
      secondaryConsent,
      selectedRelevantItems,
      travelDistance: formData?.distanceOptions,
      interestedInAtHomeTrials: formData?.homeTrailsConsentOptions,
    },
    emailVerified: isVerifiedEmail ? 'True' : 'False',
    mailingListId: sendMailingListId,
    siteSettingsId: siteSettingsId,
    language: language,
  };

  try {
    // Make the API call to fetch CDP Data
    const response = await addOrUpdateCrRegisterUser(
      `/api/contacts/AddOrUpdateCrRegistrationDetails/${guestRef}?guestType=customer`,
      payload
    );

    if (
      response?.data != null &&
      secondaryConsent?.isSecondaryConsentAccepted === 'True' &&
      secondaryConsent.isSecondaryContactMediumSMS === 'Yes' &&
      isSendSmsEnabled
    ) {
      const unblockSMSPayload = {
        FromNumber:
          (sitesettingsFromNumber != null && sitesettingsFromNumber?.indexOf('+') > -1
            ? sitesettingsFromNumber
            : `+1${sitesettingsFromNumber}`) || '',
        ToNumber:
          (payload.phoneNumbers[0]?.indexOf('+') > -1
            ? payload.phoneNumbers[0]
            : `+1${payload.phoneNumbers[0]}`) || '',
      };
      removeFromBlockList(unblockSMSPayload);
    }
    return response;
  } catch (_error) {}
};

export const addOrUpdateCrMyProfileRegDetails = async (
  source: string,
  formData: any,
  isVerifiedEmail: boolean,
  guestRef?: string,
  language?: string,
  sendMailingListId?: any,
  siteSettingsId?: any,
  isUpdate?: boolean
) => {
  const secondaryConsent = formData?.SecondaryConsentMedium
    ? {
        isSecondaryConsentAccepted: formData?.SecondaryConsentMedium ? 'True' : 'False',
        secondaryConsentAcceptedDateTime: new Date(),
        isSecondaryContactMediumPhone: formData?.SecondaryConsentMediumPhone ? 'Yes' : 'No',
        isSecondaryContactMediumEmail: formData?.SecondaryConsentMediumEmail ? 'Yes' : 'No',
        isSecondaryContactMediumSMS: Boolean(formData?.isMobile)
          ? formData?.SecondaryConsentMediumSMS
            ? 'Yes'
            : 'No'
          : 'No',
        isSecondaryContactMediumAutomatedDialer: formData?.SecondaryConsentMediumAutomatedDialer
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumArtificialVoice: formData?.SecondaryConsentMediumArtificialVoice
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumPreRecordedVoice: formData?.SecondaryConsentMediumPrerecordedVoice
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumDirectMail: formData?.SecondaryConsentMediumDirectEmail
          ? 'Yes'
          : 'No',
        isSecondaryContactMediumInsightSurveys: formData?.SecondaryConsentMediumInsightSurveys
          ? 'Yes'
          : 'No',
      }
    : null;

  const getDOB = (formData: any) => {
    if (formData?.Day && formData?.Month && formData?.Year) {
      return `${formData.Year}-${pad(
        MONTH_MAPPER[formData.Month as keyof typeof MONTH_MAPPER]
      )}-${formData.Day.toString().padStart(2, '0')}`;
    } else {
      return '';
    }
  };

  const dob = getDOB(formData);

  const selectedRelevantItems = {
    items:
      formData?.patientEnquiries?.items?.map((enquiry: any) => ({
        sitecoreId: enquiry?.sitecoreId || '',
        id: enquiry?.id || '',
        text: enquiry?.text || '',
      })) || [],
  };
  const payload = {
    ref: guestRef,
    email: formData?.Email || '',
    firstName: formData?.FirstName || '',
    lastName: formData?.LastName || '',
    postCode: formData?.Zipcode || '',
    address: formData?.CrAddress || '',
    state: formData?.State || '',
    city: formData?.City || '',
    isMobile: formData?.isMobile ? formData?.isMobile : false,
    phoneNumbers: formData.ContactNumber?.split() || [],
    zipCode: formData?.Zipcode,
    dateOfBirth: dob,
    gender: formData?.Gender,
    dataExtension: {
      source,
      secondaryConsent,
      selectedRelevantItems,
      travelDistance: formData?.distanceOptions,
      interestedInAtHomeTrials: formData?.homeTrailsConsentOptions,
    },
    emailVerified: isVerifiedEmail ? 'True' : 'False',
    mailingListId: sendMailingListId,
    siteSettingsId: siteSettingsId,
    language: language,
    isUpdate: isUpdate ?? false,
  };

  try {
    // Make the API call to fetch CDP Data
    const response = await post(`/Patient/AddOrUpdateCRRegDetails`, payload);
    return response;
  } catch (error: any) {
    logger.error(`${process.env.NEXT_PUBLIC_BASE_URL}${'/Patient/AddOrUpdateCRRegDetails'}`, {
      error: error?.message,
      payload: payload,
    });
    throw error;
  }
};

export const getProfileData = async () => {
  const myProfileVerificationToken = sessionStorage.getItem(PROFILE_VERIFY_TOKEN_KEY);
  if (myProfileVerificationToken) {
    try {
      const response = await fetchProfileDetailsForCR(myProfileVerificationToken);
      return response;
    } catch (_error) {}
  }
};

interface ISendMailProps {
  email: string;
  mailIdList: string;
  emailType: string;
  baseUrl: string;
  myProfileUrl: string;
  communityPageLink: string;
  preferredSitesPageLink?: string;
  preferredSiteName?: string;
  resendAttemptCount: number;
  siteSettingsId: string;
  language: string;
}
export const callSendEmailDapApi = async (payload: ISendMailProps) => {
  try {
    await post('/Send/AddContactsToCRMailingList', payload);
  } catch (_error) {}
};

export const checkUserRegisterOrNot = async (email: string, siteSettings: any): Promise<any> => {
  try {
    const URL = getValidateCrEmailIdURL(
      email,
      '',
      siteSettings?.source?.fields?.name?.value || 'CR',
      false
    );
    const response = await axios.get(URL);
    return !!response?.data?.isEmailExist;
  } catch (_error) {}
};

export const updateCommunitiesToCDP = async (
  COIData: ICOIAndICommunities[],
  communitiesData: ICOIAndICommunities[],
  isAppendExisting: boolean
) => {
  try {
    const myProfileVerificationToken = sessionStorage.getItem(PROFILE_VERIFY_TOKEN_KEY);
    const data = {
      myProfileToken: myProfileVerificationToken,
      conditionOfInterest: {
        items: COIData,
      },
      communities: {
        items: communitiesData,
      },
      isAppendExisting,
    };
    const cdpRes = await cdpPost('/api/contacts/UpdateConditionCommunitiesForMyProfile', data);
    return cdpRes;
  } catch (error) {
    return false;
  }
};

export const updateCommunitiesToCDPRegUser = async (
  COIData: ICOIAndICommunities[],
  communitiesData: ICOIAndICommunities[],
  isAppendExisting: boolean
) => {
  try {
    const myProfileVerificationToken = sessionStorage.getItem(PROFILE_VERIFY_TOKEN_KEY);
    const data = {
      myProfileToken: myProfileVerificationToken,
      conditionOfInterest: {
        items: COIData,
      },
      communities: {
        items: communitiesData,
      },
      isAppendExisting,
    };
    const cdpRes = await post('/Patient/UpdateConditionCommunitiesofCRRegUser', data);
    return cdpRes;
  } catch (error: any) {
    logger.error(
      `${process.env.NEXT_PUBLIC_BASE_URL}${'/Patient/UpdateConditionCommunitiesofCRRegUser'}`,
      {
        error: error?.message,
      }
    );
    throw error;
  }
};

export const updateCommunitiesToMyProfileRegUser = async (selectedCOIList: any[]) => {
  try {
    const conditionOfInterest = getStringValFromArray(selectedCOIList, 'value', 'key');
    const communityList: any[] = getCommunities(selectedCOIList);
    const communities = getStringValFromArray(communityList, 'value', 'key');

    const myProfileVerificationToken = sessionStorage.getItem(PROFILE_VERIFY_TOKEN_KEY);
    const data = {
      myProfileToken: myProfileVerificationToken,
      conditionOfInterest: {
        items: conditionOfInterest.items || [],
      },
      communities: {
        items: communities?.items || [],
      },
    };
    const cdpRes = await post('/Patient/UpdateConditionCommunitiesofCRRegUser', data);
    return cdpRes;
  } catch (error: any) {
    logger.error(
      `${process.env.NEXT_PUBLIC_BASE_URL}${'/Patient/UpdateConditionCommunitiesofCRRegUser'}`,
      {
        error: error?.message,
      }
    );
    throw error;
  }
};

export const saveSiteForMyProfile = async (siteId: string, isSaved = true) => {
  try {
    const myProfileVerificationToken = sessionStorage.getItem(PROFILE_VERIFY_TOKEN_KEY);
    const data = {
      myProfileToken: myProfileVerificationToken,
      siteId,
      isSaved,
    };
    return await cdpPost('/api/contacts/SaveSiteForMyProfile', data);
  } catch (error: any) {
    logger.error(`${process.env.NEXT_PUBLIC_CDP_API_BASE_URL}/api/contacts/SaveSiteForMyProfile`, {
      error: error?.message,
      siteId,
      isSaved,
    });
    throw error;
  }
};

export const saveSiteForCRRegUser = async (
  siteId: string,
  isSaved = true,
  siteName?: string | null
) => {
  try {
    const myProfileVerificationToken = sessionStorage.getItem(PROFILE_VERIFY_TOKEN_KEY);
    const data = {
      myProfileToken: myProfileVerificationToken,
      siteId,
      siteName: siteName ?? null,
      isSaved,
    };
    return await post('/Patient/SaveSite', data);
  } catch (error: any) {
    logger.error(`${process.env.NEXT_PUBLIC_BASE_URL}${'/Patient/SaveSite'}`, {
      error: error?.message,
    });
    throw error;
  }
};

export const saveSiteToProfile = async (
  siteId: string,
  isSaved = true,
  siteName?: string | null
) => {
  if (!siteId) {
    return false;
  }
  const response = await saveSiteForMyProfile(siteId, isSaved);
  if (process.env.NEXT_PUBLIC_ALLOW_REGISTRATION_API_CALL === 'true') {
    await saveSiteForCRRegUser(siteId, isSaved, siteName);
  }
  return response;
};
